import React, {Component} from 'react'
import {Popup} from 'semantic-ui-react'
import _ from 'lodash';
export  default  class GoxListModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
          column: null,
          data: this.props.details.goxList,
          order: true,
        }
       }

    handleSort = clickedColumn => () => {
        const { column, data, order } = this.state
    
        if (column !== clickedColumn) {
          this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            order: true,
          })
    
          return
        }
    
        this.setState({
          data: data.reverse(),
          order: !order
        })
      }

    getTableHeader = (contractType) => {
        const { column, order } = this.state;
        const direction = order ? 'down' : 'up';
            return (
            <tr>
             <th className={`cursorPointer ${column === 'practice' ? 'active': ''}`} onClick={this.handleSort('practice')}>   
              <div> Practice  <i className={`sort amount ${direction} icon ml-05`}></i></div>  
            </th>
            <th className={`cursorPointer ${column === 'patientId' ? 'active': ''}`} onClick={this.handleSort('patientId')}>
              Patient#
              <i className={`sort amount ${direction} icon ml-05`}></i>
            </th>
              <th className={`cursorPointer ${column === 'dateOfService' ? 'active': ''}`} onClick={this.handleSort('dateOfService')}>
              Date Of Service
              <i className={`sort amount ${direction} icon ml-05`}></i>
            </th>
            <th className={`cursorPointer ${column === 'procCode' ? 'active': ''}`} >
              Proc Code
              <i className={`sort amount ${direction} icon ml-05`}></i>
            </th>
            <th className={`cursorPointer ${column === 'bCare' ? 'active': ''}`} >
              bCare
              <i className={`sort amount ${direction} icon ml-05`}></i>
            </th>
            <th className={`cursorPointer ${column === 'bCare' ? 'active': ''}`} onClick={this.handleSort('price')}>
              X-deductions
              <i className={`sort amount ${direction} icon ml-05`}></i>
            </th>
          </tr>
            )
    }
      
    getTableData = (data,billableCareData,getPracticeName) => {
        let returnArray = [];
        let totalPrice = 0;
        let totalbCare = 0;
        let totalWriteOff = 0;
        let uniKey = 0;
        let totalXdeductions=0;
        let bCareObj={}

        billableCareData.forEach((bdata)=>{
          if(bCareObj[bdata.ProcDate+bdata.Practice+bdata.PatNum]){
            bCareObj[bdata.ProcDate+bdata.Practice+bdata.PatNum].bCare+=bdata.bCare;
          }
          else{
            bCareObj[bdata.ProcDate+bdata.Practice+bdata.PatNum]=bdata;
          }
          
          })
      
        if(data.length) {
            data.forEach( (item) => {
              totalXdeductions += item.bCare;
              totalbCare+=bCareObj[item.dateOfService+item.practice+item.patientId].bCare
              uniKey++;
              returnArray.push(
                <tr key={uniKey}>
                  <td>{getPracticeName(item.practice)}</td>
                  <td className="primaryColor cursorPointer"><span >{ item.patientId }</span></td>
                  <td>{ item.dateOfService }</td>
                  <td><Popup trigger={<div>{this.trimString(item.procCode, 15, false)}</div>} content={item.procCode} /></td>
                  <td>${ (bCareObj[item.dateOfService+item.practice+item.patientId].bCare).toFixed(2) }</td>
                  <td>${ item.bCare.toFixed(2) }</td>
                </tr>   
              );
           });
           returnArray.push(
             <tr key={"total"}>
               <td colSpan="4"><strong>Total</strong></td>
                  <td><strong>${totalbCare.toFixed(2)}</strong></td>
                  <td><strong>${totalXdeductions.toFixed(2)}</strong></td>
             </tr>
           );
           return <tbody>{returnArray}</tbody>
        } else {
          return (
            <tbody>
              <tr>
                <td colSpan="6">No Record Found</td>
              </tr>
            </tbody>
          );
        }
    }

    trimString = (str, len, addDots) => {
        return (
          (str && str.length > len) ?
          (addDots !== false ?
            str.substring(0, len - 3) :
            str.substring(0, len - 3) + '...') :
          str);
      }

    render() {
        const {details,getPracticeName,providerData} = this.props;
        const {goxList,billableCareData}=details;
        return (
             <div>
                 <table className="table table-striped fixed compact table-hover my-0 TableHeaderFixed">
                    <thead>
                     {this.getTableHeader(providerData.contractType)}
                     </thead>
                     {this.getTableData(goxList,billableCareData,getPracticeName)}
                 </table>
             </div>

        )
    }

}
